﻿import { showToast } from './toast.js';

function getBaseHeaders() {
    return {
        'X-Requested-With': 'XMLHttpRequest',
        'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]')?.value ?? ''
    };
}

async function bookerFetch(url, options = {}) {
    try
    {
        const response = await fetch(url, {
            ...options,
            headers: {
                ...getBaseHeaders(),
                ...options.headers
            }
        });

        const text = await response.text();

        if (response.status >= 500) {
            showToast('error', text || "Une erreur inattendue s'est produite.");
            return { status: response.status, text: null };
        }

        return { status: response.status, text };

    }
    catch (error) {
        console.error('Erreur réseau : ', error);
        showToast('error', "Une erreur réseau s'est produite.");
        return { status: 0, text: null };
    }
}

export async function bookerGet(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    return bookerFetch(fullUrl, { method: 'GET' });
}

export async function bookerPost(url, body) {
    return bookerFetch(url, { method: 'POST', body });
}

export async function bookerPut(url, body) {
    return bookerFetch(url, { method: 'PUT', body });
}

export async function bookerDelete(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    return bookerFetch(fullUrl, { method: 'DELETE' });
}

function extractFileName(contentDisposition) {
    if (!contentDisposition) return null;
    const matches = /filename[^;=\n]*=((['"]).*\2|[^;\n]*)/.exec(contentDisposition);
    if (matches?.[1]) {
        return matches[1].replace(/['"]/g, '');
    }
    return null;
}

export async function bookerPostBlob(url, body) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...getBaseHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (response.status >= 500) {
            const text = await response.text();
            showToast('error', text || "Une erreur inattendue s'est produite.");
            return { status: response.status, blob: null, fileName: null };
        }

        const blob = await response.blob();
        const fileName = extractFileName(response.headers.get('Content-Disposition'));

        return { status: response.status, blob, fileName };
    } catch (error) {
        console.error('Erreur réseau : ', error);
        showToast('error', "Une erreur réseau s'est produite.");
        return { status: 0, blob: null, fileName: null };
    }
}

export async function bookerPostJson(url, data) {
    return bookerFetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
}